import React from "react";

const ProductManagementList = React.lazy(() => import('src/pages/product_management/ProductManagementList'));
const AddProductManagement = React.lazy(() => import('src/pages/product_management/AddProductManagement'));
const EditProductManagement = React.lazy(() => import('src/pages/product_management/EditProductManagement'));
// const ViewProductManagement = React.lazy(() => import('src/pages/product_management/ViewProductManagement'));

const routes = [
    { path: '/dashboard/product-management-list/add', name: 'Add', element: AddProductManagement },
    { path: '/dashboard/product-management-list/edit', name: 'Edit', element: EditProductManagement },
    // { path: '/dashboard/product-management-list/view/:id', withParam: true, exact: true, name: "", element: ViewProductManagement },
    { path: '/dashboard/product-management-list', name: 'Product Management', element: ProductManagementList },
];

export default routes;